import { useState, useEffect } from 'react';

/**
 * A hook that keeps local state in sync with a prop value
 * [Warning!] Use sparingly - if you're considering using this hook, there's probably a better way for you to structure state.
 * Ideally we should always have **one source of truth** for any piece of state, and we should never need to use this hook.
 *
 * @param propValue The prop value to sync with
 * @returns A stateful value and a function to update it
 */
const useSyncedState = <T>(
  propValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [state, setState] = useState<T>(propValue);

  useEffect(() => {
    setState(propValue);
  }, [propValue]);

  return [state, setState];
};

export default useSyncedState;
